import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';

import NavTabElement from '@components/header/nav-tab-element/NavTabElement';
import './NavTabsGroup.scss';

const NavTabsGroup = ({ navTabsConfig, isHelpActive }) => {
  return (
    <div id="qau-header-nav-tabs" data-testid="qau-header-nav-tabs" className={classnames({ 'help-active': isHelpActive })}>
      {navTabsConfig.map(NavTabElement)}
    </div>
  );
};

const mapStateToProps = ({ header, help }) => ({
  navTabsConfig: header.tabs,
  isHelpActive: !!help.activated,
});

NavTabsGroup.propTypes = {
  navTabsConfig: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      locKey: PropTypes.string.isRequired,
      active: PropTypes.bool.isRequired,
      hidden: PropTypes.bool.isRequired,
    }),
  ).isRequired,
  isHelpActive: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(NavTabsGroup);
